import { ComponentRenderType } from 'constants/enums'
import { ComponentBase } from './component-base'

/**
 * Lazy load render() by Intersection Observer
 */
export abstract class AbstractObserver extends ComponentBase {
    static type: ComponentRenderType

    public constructor(
        protected el: HTMLElement,
        protected useIntersectionObserver = true
    ) {
        super()
    }

    /**
     * The options object passed into the IntersectionObserver() constructor.
     * @param {options} IntersectionObserverInit
     * ex: activateObserver({rootMargin: '200px'})
     */
    protected activateObserver(options?: IntersectionObserverInit): void {
        if (this.useIntersectionObserver) {
            const observer = new IntersectionObserver(
                this.observerCallback.bind(this),
                options
            )
            observer.observe(this.el)
            return
        }

        this.render()
    }

    /**
     * Callback for Intersection Observer
     * @param {entries} IntersectionObserverEntry[]
     * @param {observer} IntersectionObserver
     */
    private observerCallback(
        entries: IntersectionObserverEntry[],
        observer: IntersectionObserver
    ): void {
        entries.forEach((entry: IntersectionObserverEntry) => {
            // if the entry is in the intersection port, call loadData
            if (entry.isIntersecting) {
                this.render()
                observer.unobserve(entry.target)
            }
        })
    }

    abstract render(): void
}
